import { useQuery } from "react-query";
import MunicipalityScreen from "..";
import Context from "../../../context";
import api from "../../../api";
import values from "../../../values";
import { useState } from "react";
import { TModal } from "../../../types/common.type";
import {
  ICreateAndUpdateMunicipality,
  IRequestMunicipality,
} from "../../../types/municipality.interface";
import utils from "../../../utils";

const MunicipalityContainer = () => {
  const [showModal, setShowModal] = useState<TModal>();
  const [loading, setLoading] = useState<boolean>(false);
  const [selectedMunicipality, setSelectedMunicipality] =
    useState<ICreateAndUpdateMunicipality>();
  const [requestMunicipality, setRequestMunicipality] =
    useState<IRequestMunicipality>({
      page: 1,
      limit: values.constants.PANEL_TABLE_DEFAULT_LIMIT,
    });

  const resultMunicipality = useQuery(
    [values.useQueryKeys.getAllMunicipality, requestMunicipality],
    () =>
      api.postMethod.administrator.getAllMunicipality({
        ...requestMunicipality,
      })
  );

  const updateMunicipality = async (
    Municipality: ICreateAndUpdateMunicipality
  ) => {
    setLoading(true);
    const result = await api.putMethod.administrator.updateMunicipality(
      Municipality
    );
    if (result) {
      resultMunicipality.refetch();
      setLoading(false);
      setShowModal("NONE");
      utils?.successHandler(result?.CODE);
      return true;
    } else {
      utils?.errorHandler(result?.CODE);
      setLoading(false);
      return false;
    }
    return true;
  };
  const createMunicipality = async (
    MunicipalityInfo: ICreateAndUpdateMunicipality
  ) => {
    setLoading(true);
    const result = await api.postMethod.administrator.createMunicipality(
      MunicipalityInfo
    );
    if (result) {
      resultMunicipality.refetch();
      setLoading(false);
      setShowModal("NONE");
      utils?.successHandler(result?.CODE);
      return true;
    } else {
      utils?.errorHandler(result?.CODE);
      setLoading(false);
      return false;
    }
  };
  const removeMunicipality = async (_id: string) => {
    setLoading(true);
    const result = await api.deleteMethod.administrator.deleteMunicipality(_id);
    if (result) {
      resultMunicipality.refetch();
      setLoading(false);
      setShowModal("NONE");
      utils?.successHandler(result?.CODE);
      return true;
    } else {
      utils?.errorHandler(result?.CODE);
      setLoading(false);
      return false;
    }
  };

  return (
    <Context.MunicipalityScreen.Provider
      value={{
        resultMunicipality,
        requestMunicipality,
        setRequestMunicipality,
        showModal,
        setShowModal,
        selectedMunicipality,
        setSelectedMunicipality,
        loading,
        setLoading,
        updateMunicipality,
        createMunicipality,
        removeMunicipality,
      }}
    >
      <MunicipalityScreen />
    </Context.MunicipalityScreen.Provider>
  );
};

export default MunicipalityContainer;
